import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-muted antialiased" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mj6jvxrnc2gi" />
      <main data-id="element-2" data-mp="3rcj7q5oi4587">
        <Hero data-id="element-3" data-mp="3rbrcwx2qabiz" />
        <SocialProof data-id="element-4" data-mp="3rdar8i4tqci4" />
        <Testimonials data-id="element-5" data-mp="3rd1bdndhtlq5" />
        <ProblemSection data-id="element-6" data-mp="3relv0hy9rk98" />
        <SystemSection data-id="element-7" data-mp="6hrlipoilfp" />
        <ModulesSection data-id="element-8" data-mp="4wyzymxdckh" />
        <BonusSection data-id="element-9" data-mp="56m9egl55mh" />
        <UrgencySection data-id="element-10" data-mp="2zl39tfhhuw2o" />
        <PricingSection data-id="element-11" data-mp="2zlld2w2kqak3" />
        <MoreResults data-id="element-12" data-mp="2zmeo498kfm81" />
        <GuaranteeSection data-id="element-13" data-mp="2zmwlj96ys6hj" />
        <FAQ data-id="element-14" data-mp="33mowfsjtyoq2" />
        <ClosingSection data-id="element-15" data-mp="33m5a7zn5de68" />
        <SummaryTable data-id="element-16" data-mp="33nges1of2pye" />
        <FinalCta data-id="element-17" data-mp="33mykvbp88ntn" />
      </main>
      <Footer data-id="element-18" data-mp="38lrrqla0dgku" />
      <PurchaseNotification data-id="element-19" data-mp="38l8gtoirzsgb" />
    </div>;
}